import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { useAuth } from "../../auth/AuthContext";
import "./SemTurma.scss";

export default function SemTurma() {
  const navigate = useNavigate();
  const { sair, usuario } = useAuth();
  const tipo = String(usuario?.tipo || "").toLowerCase();
  const ehCoordenador = tipo === "coordenador";

  // Se o usuário tem vínculo (coordenação para coord, turma para responsável),
  // não deve permanecer em /sem-turma. Redireciona para dashboard.
  useEffect(() => {
    if (!usuario) return;
    const coordenacoes = Array.isArray(usuario.coordenacoesComoCoordenador)
      ? usuario.coordenacoesComoCoordenador
      : [];
    const turmas = Array.isArray(usuario.turmas) ? usuario.turmas : [];
    const semVinculo =
      tipo === "coordenador" ? coordenacoes.length === 0 : turmas.length === 0;
    if (!semVinculo) navigate("/dashboard", { replace: true });
  }, [usuario, tipo, navigate]);

  const handleVoltarLogin = async () => {
    try {
      await sair();
    } finally {
      navigate("/");
    }
  };

  const subtitle = ehCoordenador ? (
    <>
      Sua <strong>conta está ativa</strong>, mas{" "}
      <strong>não está vinculada a nenhuma coordenação</strong> no momento. Isso pode
      ocorrer devido algum erro ou atualização no sistema.
    </>
  ) : (
    <>
      Sua <strong>conta está ativa</strong>, mas{" "}
      <strong>não está vinculada a nenhuma turma</strong> no momento. Isso pode
      ocorrer caso sua permissão tenha sido alterada pela coordenação ou devido
      a atualização no sistema.
    </>
  );

  return (
    <div className="sem-turma">
      <div className="sem-turma__card">
        <h1 className="sem-turma__title">
          No momento você não possui
          <br />
          acesso a nenhuma {ehCoordenador ? "coordenação" : "turma"}
        </h1>

        <p className="sem-turma__subtitle">{subtitle}</p>

        <section className="sem-turma__panel">
          <h2 className="sem-turma__panel-title">
            O que você pode fazer agora:
          </h2>
          <ul className="sem-turma__list">
            {!ehCoordenador && (
              <li>
                <strong>Entrar em contato com a coordenação</strong>
                <p>
                  Se você acredita que foi engano, entre em contato com o
                  responsável da sua instituição.
                </p>
              </li>
            )}
            <li>
              <strong>Aguardar atualização do sistema</strong>
              <p>
                Constantemente atualizamos nosso sistema para melhor sua
                experiência, por isso, podemos estar passando por atualizações
                no momento. Aguarde e tente novamente mais tarde.
              </p>
            </li>
          </ul>
        </section>

        <section className="sem-turma__ajuda">
          <h3 className="sem-turma__ajuda-title">Precisa de ajuda?</h3>
          <p className="sem-turma__ajuda-p">
            Caso o problema persista, entre em contato conosco
          </p>
          <a
            href="mailto:uniagenda.contato@gmail.com"
            className="sem-turma__email"
          >
            <Mail size={16} /> uniagenda.contato@gmail.com
          </a>
        </section>

        <button
          type="button"
          className="sem-turma__cta"
          onClick={handleVoltarLogin}
        >
          Voltar para a tela de login
        </button>
      </div>
    </div>
  );
}
